import { useTheme } from '@mui/material'

export function Pagination({ index }: { index: number }) {
  const theme = useTheme()
  return (
    <div style={{ display: 'flex', gap: '4px' }}>
      {Array(3)
        .fill(null)
        .map((_, current) => (
          <div
            style={{
              width: current === index ? '16px' : '8px',
              height: '8px',
              borderRadius: '6px',
              backgroundColor:
                current === index
                  ? theme.palette.secondary500
                  : theme.palette.neutral300,
            }}
          />
        ))}
    </div>
  )
}
